import axiosClient from "./axiosClient";

const endpoint = "/commerce/order-policy-profiles";
const optionsEndpoint = "/commerce/order-policy-profile-options";
const silent = { __silentGenericToast: true };

export const orderPolicyProfilesApi = {
  async listOptions(includeInactive = true) {
    const response = await axiosClient.get(optionsEndpoint, {
      ...silent,
      params: { includeInactive },
    });
    return response.data;
  },
  async list(includeInactive = true) {
    const response = await axiosClient.get(endpoint, {
      ...silent,
      params: { includeInactive },
    });
    return response.data;
  },
  async get(profileId) {
    const response = await axiosClient.get(`${endpoint}/${profileId}`, silent);
    return response.data;
  },
  async create(profile) {
    const response = await axiosClient.post(endpoint, profile, silent);
    return response.data;
  },
  async update(profileId, profile) {
    const response = await axiosClient.put(`${endpoint}/${profileId}`, profile, silent);
    return response.data;
  },
  async setDefault(profileId, expectedVersion) {
    const response = await axiosClient.post(
      `${endpoint}/${profileId}/default`,
      { expectedVersion },
      silent,
    );
    return response.data;
  },
  async activate(profileId, expectedVersion) {
    const response = await axiosClient.post(
      `${endpoint}/${profileId}/activate`,
      { expectedVersion },
      silent,
    );
    return response.data;
  },
  async deactivate(profileId, expectedVersion) {
    const response = await axiosClient.delete(`${endpoint}/${profileId}`, {
      ...silent,
      params: { expectedVersion },
    });
    return response.data;
  },
};
